export class PatientAlreadyExistsError extends Error {
  constructor() {
    super('Paciente já cadastrado')
    this.name = 'PatientAlreadyExistsError'
  }
}
